export default "__VITE_ASSET__BSPd6urY__"